var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.hanldeClickContent}},[_c('div',{staticClass:"contentWrap ql-editor",class:{dark: _vm.$vuetify.theme.dark},domProps:{"innerHTML":_vm._s(_vm.coverContent(_vm.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }